import { RenderIf } from 'react-rainbow-components';
import TimeIcon from 'components/icons/time';
import FloppyIcon from 'components/icons/floppy';
import { ValidationStatusSpan } from 'components/ValidationStatus/styled';
import {
    StyledFooter,
    FooterButton,
    LeftButtonsContainer,
} from './styled';
import checkHasPromptCommands from './helpers/checkHasPromptCommands';

interface FormFooterProps {
    formId?: string;
    submitLoading?: boolean;
    content?: string;
    onOpenHistory?: (value: boolean) => void;
    historyOpen?: boolean;
    hideHistoryAction?: boolean;
    onsubmit?: () => void;
}

const FormFooter = ({
    formId,
    content = '',
    submitLoading = false,
    hideHistoryAction = false,
    onOpenHistory = () => {},
    historyOpen = false,
    onsubmit = () => {},
}: FormFooterProps) => (
    <StyledFooter>
        <LeftButtonsContainer>
            <RenderIf isTrue={checkHasPromptCommands(content)}>
                <ValidationStatusSpan variant="error">Only text is allowed</ValidationStatusSpan>
            </RenderIf>
        </LeftButtonsContainer>
        <div className="rainbow-m-left_medium">
            <RenderIf isTrue={!hideHistoryAction}>
                <FooterButton
                    borderRadius="semi-square"
                    onClick={() => onOpenHistory(!historyOpen)}
                    disabled={historyOpen}
                    icon={<TimeIcon />}
                    title="History"
                />
            </RenderIf>
            <FooterButton
                type="submit"
                variant="base"
                form={formId}
                borderRadius="semi-square"
                onClick={() => onsubmit()}
                disabled={submitLoading || checkHasPromptCommands(content)}
                icon={<FloppyIcon />}
                title="Save Changes"
            />
        </div>
    </StyledFooter>
);

export default FormFooter;
